$(".msdw-headvisual").slick({
  accessibility: false, // page jumping bug fix
  dots: false,
  arrows: true,
  infinite: true,
  autoplay: true,
  speed: 1000,
  autoplaySpeed: 5000,
  fade: true,
  //slidesToShow: 1,
  //initialSlide: 0,
  //slidesToScroll: 1,
  responsive: [
  {
  breakpoint: 600,
    settings: {
      arrows: false,
      dots: true
    }
  }
]
});

$(window).on('orientationchange resize', function() {
  $('.msdw-headvisual').slick('resize');
});



